import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import * as moment from 'moment'

import { Modal } from 'components/Modal'
import { WarningModal } from 'components/Modal'
import { Form } from 'components/forms'
import { useMutation, updateQuery } from 'components/graphql'
import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'
import { listDateOrderValues } from '../../gql'
import createDateOrderMutation from '../../gql/mutation/createDayOrder'
import updateDateOrderMutation from '../../gql/mutation/updateDayOrder'
import DayOrderModalForm from './DayOrderModalForm'

const DayOrderModal = props => {
	const [t] = useTranslation()
	const [createDateOrder] = useMutation(createDateOrderMutation)
	const [updateDateOrder] = useMutation(updateDateOrderMutation)
	const [errors, setErrors] = useState('')

	const submitHandler = ({ creditClientId, productId, date, ...other }) => {
		let existErrors = ''
		if (moment(date) < moment(new Date()).utc().startOf('day')) {
			existErrors += `Selected date should be greater or equal to ${moment(new Date()).format('DD.MM.YYYY')}. `
			setErrors(existErrors)
		}
		const isNew = Object.keys(props.data).length === 1
		if (existErrors === '') {
			if (isNew) {
				createDateOrder({
					variables: {
						required: { creditClientId, productId, date },
						fields: { ...other }
					},
					update: updateQuery({
						query: listDateOrderValues,
						variables: { id: props.data.creditClientId, dateInterval: props.dateInterval } }, (draft, { mutationResult, readQuery, queryField }) => {
						const oldItems = [...readQuery.items]
						const newItems = oldItems.concat([mutationResult])
						draft[queryField].items = newItems
					})
				})
				props.unmount()
			} else {
				const mutationName = getNameOfGqlQuery(updateDateOrderMutation)
				updateDateOrder({
					variables: {
						id: props.data.id,
						fields: { creditClientId, productId, date, ...other }
					},
					update: updateQuery({
						query: listDateOrderValues,
						variables: { id: props.data.creditClientId, dateInterval: props.dateInterval } }, (draft, { mutationResult, readQuery, queryField }) => {
						const newData = readQuery.items.map((item = {}) => Number(item.id) === Number(mutationResult.id) ? { ...item, mutationResult } : item)
						draft[queryField].items = newData
					}),
					optimisticResponse: {
						cashAssist: {
							[mutationName]: {
								__typename: 'DateOrderValues',
								id: props.data.id,
								date,
								proposedAmount: props.data.proposedAmount,
								product: props.data.product,
								...other
							},
							__typename: 'CA_Mutation'
						}
					}
				})
				props.unmount()
			}
		}
	}

	return(
		<>
			<Modal {...props} width={410} label={t('credit_client_section.strings.create_day_order')}>
				<Form
					initialValues={props.data}
					onSubmit={submitHandler}
					render={() => (
						<DayOrderModalForm
							id={props.id}
							unmount={props.unmount}/>
					)}/>
			</Modal>
			{errors !== '' &&
			<WarningModal
				label={t('credit_client_section.strings.warning')}
				text={errors}
				onClose={() => setErrors('')}/>
			}
		</>
	)
}

export default DayOrderModal
